import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroImage from "@/assets/hero-costa-rica.jpg";
import { useLocale } from "@/contexts/LocaleContext";

const HeroSection = () => {
  const { isUSVisitor } = useLocale();

  if (isUSVisitor) {
    return (
      <section className="bg-background border-b border-border">
        <div className="container mx-auto px-4 py-8 md:py-14">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="order-2 md:order-1">
              <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary mb-3">
                Handmade · Costa Rica
              </span>
              <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-foreground mb-4">
                Gifts with soul,<br />
                made by artisans.
              </h1>
              <p className="text-base md:text-lg text-muted-foreground mb-6 max-w-md leading-relaxed">
                Discover one-of-a-kind pieces from Costa Rican makers — now shipping to the US.
              </p>
              <Link to="/productos">
                <Button size="lg" className="rounded-full px-8 h-12 text-base">
                  Shop the marketplace
                </Button>
              </Link>
            </div>
            <div className="order-1 md:order-2 relative">
              <div className="aspect-[4/3] md:aspect-[5/4] overflow-hidden rounded-2xl shadow-sm">
                <img
                  src={heroImage}
                  alt="Handmade goods from Costa Rica"
                  className="w-full h-full object-cover"
                  loading="eager"
                  fetchPriority="high"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-background border-b border-border">
      <div className="container mx-auto px-4 py-8 md:py-14">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Copy */}
          <div className="order-2 md:order-1">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary mb-3">
              Hecho a mano · Costa Rica
            </span>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-foreground mb-4">
              Regalos con alma,<br />
              hechos en Costa Rica.
            </h1>
            <p className="text-base md:text-lg text-muted-foreground mb-6 max-w-md leading-relaxed">
              Descubrí piezas únicas de artesanos, diseñadores y emprendedores ticos.
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <Link to="/productos">
                <Button size="lg" className="rounded-full px-7 h-12 text-base">
                  Explorar la Feria
                </Button>
              </Link>
              <Link
                to="/vender"
                className="text-sm font-semibold text-foreground underline underline-offset-4 decoration-primary/60 hover:decoration-primary"
              >
                ¿Tenés tienda? Vendé con nosotros →
              </Link>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 md:order-2 relative">
            <div className="aspect-[4/3] md:aspect-[5/4] overflow-hidden rounded-2xl shadow-sm">
              <img
                src={heroImage}
                alt="Productos artesanales de Costa Rica"
                className="w-full h-full object-cover"
                loading="eager"
                fetchPriority="high"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
